import { render, staticRenderFns } from "./springback.vue?vue&type=template&id=444cff45&scoped=true"
import script from "./springback.vue?vue&type=script&lang=js"
export * from "./springback.vue?vue&type=script&lang=js"
import style0 from "./springback.vue?vue&type=style&index=0&id=444cff45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444cff45",
  null
  
)

export default component.exports